import { useToast } from "@chakra-ui/react";
import { createContext, ReactNode, useCallback, useState } from "react";
import inventory from "services/inventory";
import { useImmer } from "use-immer";

import { IInventoryContext } from "../../Interfaces/Providers/Inventory";
interface Auth0ProviderProps {
  children: ReactNode;
}

const InventoryProvider = ({ children }: Auth0ProviderProps) => {
  const toast = useToast();

  const [loading, setLoading] = useState(false);
  const [isFirstData, setFirstData] = useState(true);

  const [data, updateData] = useImmer<any[]>([]);

  const [loadingHistoric, setLoadingHistoric] = useState(false);
  const [dataHistoric, updateDataHistoric] = useImmer<any[]>([]);

  const getDataHistoric = useCallback(async () => {
    setLoadingHistoric(true);
    setFirstData(false);

    inventory
      .getInventoryHistoric()
      .then((response) => {
        updateDataHistoric(response.data?.data);
        setLoadingHistoric(false);
      })
      .catch(() => {
        setLoadingHistoric(false);
      });
  }, [updateDataHistoric]);
  const getData = useCallback(async () => {
    setLoading(true);
    setFirstData(false);

    inventory
      .getInventory()
      .then((response) => {
        updateData(response.data?.data);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  }, [updateData]);

  const postData = useCallback(
    async (obj: any) => {
      setLoading(true);
      setFirstData(false);

      inventory
        .postInventory(obj)
        .then((response) => {
          getData();
          toast({
            title: "Inventário cadastrado com Sucesso.",
            status: "success",
            duration: 3000,
            position: "top",
            isClosable: true,
          });
        })
        .catch(() => {
          setLoading(false);
          toast({
            title: "Error ao cadastrar..",
            status: "error",
            duration: 3000,
            position: "top",
            isClosable: true,
          });
        });
    },
    [updateData]
  );

  const putData = useCallback(
    async (obj: any, id: any) => {
      setLoading(true);
      setFirstData(false);

      inventory
        .putInventory(obj, id)
        .then((response) => {
          setLoading(false);
          getData();
          toast({
            title: "Inventário atualizado com Sucesso.",
            status: "success",
            duration: 3000,
            position: "top",
            isClosable: true,
          });
        })
        .catch(() => {
          setLoading(false);
          toast({
            title: "Error ao atualizar..",
            status: "error",
            duration: 3000,
            position: "top",
            isClosable: true,
          });
        });
    },
    [updateData]
  );

  const deleteData = useCallback(
    async (id: number) => {
      setLoading(true);
      setFirstData(false);

      inventory
        .deleteInventory(id)
        .then((response) => {
          getData();
          toast({
            title: "Inventário deletado com Sucesso.",
            status: "success",
            duration: 3000,
            position: "top",
            isClosable: true,
          });
        })
        .catch(() => {
          setLoading(false);
          toast({
            title: "Error ao deletar..",
            status: "error",
            duration: 3000,
            position: "top",
            isClosable: true,
          });
        });
    },
    [getData]
  );

  return (
    <InventoryContext.Provider
      value={{
        loading,
        data,
        isFirstData,
        getData,
        deleteData,
        putData,
        postData,
        dataHistoric,
        loadingHistoric,
        getDataHistoric,
      }}
    >
      {children}
    </InventoryContext.Provider>
  );
};

export default InventoryProvider;
export const InventoryContext = createContext<IInventoryContext>(
  {} as IInventoryContext
);
